/**
 * Content policy option ids i.e. the user subcription id
 * provided by user entitlment
 * @module services/content-policy/option-ids
 */

/**
 * Content policy for origial basic subscription
 * @deprecated This will remain for backwards compatibiliy
 * with Sony PS3, but most likely you want CONTENT_POLICY_OPTION_SUB_MONTHLY
 */
export const CONTENT_POLICY_OPTION_SUB_BASIC = 252

/**
 * Content policy basic subscription
 */
export const CONTENT_POLICY_OPTION_SUB_MONTHLY = 253

/**
 * Content policy annual subscription
 */
export const CONTENT_POLICY_OPTION_SUB_ANNUAL = 280

/**
 * Content policy premium subscription
 */
export const CONTENT_POLICY_OPTION_SUB_LIVE_ACCESS = 290

/**
 * Content policy available to any subscription
 */
export const CONTENT_POLICY_OPTION_FREE = 255

/**
 * Content policy alacarte
 */
export const CONTENT_POLICY_OPTION_ALACARTE = 222

/**
 * Content policy AI subscription
 */
export const CONTENT_POLICY_OPTION_SUB_AI_ONLY = 200

/**
 * Get the option ids options
 * @returns {Array} The option ids options
 */
export function getOptionIdsOptions () {
  return [
    { label: 'Sub Basic', value: CONTENT_POLICY_OPTION_SUB_BASIC },
    { label: 'AI Only', value: CONTENT_POLICY_OPTION_SUB_AI_ONLY },
    { label: 'Sub Monthly', value: CONTENT_POLICY_OPTION_SUB_MONTHLY },
    { label: 'Sub Annual', value: CONTENT_POLICY_OPTION_SUB_ANNUAL },
    { label: 'Live Access', value: CONTENT_POLICY_OPTION_SUB_LIVE_ACCESS },
    { label: 'Free', value: CONTENT_POLICY_OPTION_FREE },
    { label: 'Alacarte', value: CONTENT_POLICY_OPTION_ALACARTE },
  ]
}

/**
 * Get the standard content policy options
 * @returns {Array} The standard content policy options
 */
export function getStandardContentPolicyOptionIdsOptions () {
  return [
    {
      label: `Monthly subscription (${CONTENT_POLICY_OPTION_SUB_MONTHLY})`,
      value: CONTENT_POLICY_OPTION_SUB_MONTHLY,
    },
    {
      label: `Annual subscription (${CONTENT_POLICY_OPTION_SUB_ANNUAL})`,
      value: CONTENT_POLICY_OPTION_SUB_ANNUAL,
    },
    {
      label: `Gaia+ subscription (${CONTENT_POLICY_OPTION_SUB_LIVE_ACCESS})`,
      value: CONTENT_POLICY_OPTION_SUB_LIVE_ACCESS,
    },
    {
      label: `Alacarte (${CONTENT_POLICY_OPTION_ALACARTE})`,
      value: CONTENT_POLICY_OPTION_ALACARTE,
    },
    {
      label: `AI Only subscription (${CONTENT_POLICY_OPTION_SUB_AI_ONLY})`,
      value: CONTENT_POLICY_OPTION_SUB_AI_ONLY,
    },
  ]
}
